export const DATE_DISPLAY_FORMAT = 'MMM D YYYY'